/*
  rbk-home.js — homepage scroll reveals.
  Tags below-the-fold elements and fades them in once as they enter view.
  No-op under reduced motion or no IntersectionObserver; the hidden state only
  exists once JS adds .rbk-reveal-ready, so those contexts always render visible.
*/
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTORS = ['.rbk-best-sellers__heading', '.rbk-best-sellers__card'];
  var els = [];
  SELECTORS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (els.indexOf(el) === -1) els.push(el);
    });
  });
  if (!els.length) return;

  document.documentElement.classList.add('rbk-reveal-ready');
  els.forEach(function (el) { el.setAttribute('data-rbk-reveal', ''); });

  // Stagger the product cards within the grid.
  document.querySelectorAll('.rbk-best-sellers__grid .rbk-best-sellers__card').forEach(function (card, i) {
    card.style.transitionDelay = (i * 70) + 'ms';
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

  els.forEach(function (el) { io.observe(el); });
})();
